import merge from "@suid/utils/merge";
export const componentsDefault = createComponentsOptions({});
export function createComponentsOptions(options) {
    return options;
}
export function createComponents(data) {
    const result = {
        ...merge({}, componentsDefault, data ?? {}),
    };
    return result;
}
